import Seo from "@/components/seo/Seo"

import HeroPremium from "@/components/sections/HeroPremium"
import Features from "@/components/sections/Features"
import HowItWorks from "@/components/sections/HowItWorks"
import Reviews from "@/components/sections/Reviews"
import PropertyGrid from "@/components/sections/PropertyGrid"
import ComparisonCreative from "@/components/sections/ComparisonCreative"
import StatsStrip from "@/components/sections/StatsStrip"

import ErrorBoundary from "@/components/common/ErrorBoundary"
import SectionReveal from "@/components/common/SectionReveal"

export default function Home() {
  return (
    <>
      <Seo
        title="Zenia Stays | Premium Airbnb Management"
        description="Premium Airbnb and short-term rental management focused on maximizing occupancy, guest experience, and property revenue."
        canonical="https://zeniastays.com/"
      />

      <HeroPremium />

      <ErrorBoundary>

        <SectionReveal>
          <StatsStrip />
        </SectionReveal>

        <SectionReveal delay={0.04}>
          <Features />
        </SectionReveal>

        <SectionReveal delay={0.06}>
          <HowItWorks />
        </SectionReveal>

        <SectionReveal delay={0.08}>
          <PropertyGrid />
        </SectionReveal>

        <SectionReveal delay={0.1}>
          <ComparisonCreative />
        </SectionReveal>

        <SectionReveal delay={0.12}>
          <Reviews />
        </SectionReveal>

      </ErrorBoundary>
    </>
  )
}